import { useTranslations } from 'next-intl';
import React from 'react';

import ContentTitle from '@/components/ContentTitle';
import ShowingListItemImage from '@/components/ShowingListItemImage';

import { HrefOrHrefWithParams } from 'next-intl/dist/types/navigation/shared/utils';

import { CachedContentData } from '@/hooks/useCachedContentData';

import AllShowingDaysSlider from './AllShowingDaysSlider';

type ProgramMobileListItemLayoutProps = {
    href?: HrefOrHrefWithParams<'/program/[contentId]'>;
    content: CachedContentData;
    totalItems: number;
    selectedDate?: string | 'all';
};

export function ProgramMobileListItemLayout(props: ProgramMobileListItemLayoutProps): React.JSX.Element {
    const { href, content, totalItems, selectedDate } = props;
    const t = useTranslations();
    return (
        <div
            className="flex flex-col py-16 space-y-12"
            role="group"
            aria-label={content.title}>
            <ContentTitle
                href={href}
                content={content}
                showMovieDuration
                showGenres
            />
            <ShowingListItemImage
                href={href}
                content={content}
            />
            <div className="text-body-bold-12 italic">{t('specials.n-showings', { count: totalItems })}</div>
            <AllShowingDaysSlider
                content={content}
                selectedDate={selectedDate}
            />
        </div>
    );
}
